import axiosInstance from "src/utils/axios";

const usersAutoCompleteWithAdmin = async (term, params = {}) => {
  const reqData = new FormData();
  const { user_id, ...rest } = params;
  reqData.append("term", term);
  if (user_id) {
    reqData.append("user_id[]", user_id);
  }
  try {
    const { data } = await axiosInstance.post(
      "/api/admin/change-sponsor/autocomplete",
      reqData,
      {
        params: { ...rest },
      }
    );

    return data;
  } catch (err) {
    return err;
  }
};

export default usersAutoCompleteWithAdmin;